export default __webpack_public_path__ + "static/media/database-done.00adfd48.svg";